const sitePagesPageType = {
  blogPost: "blogPost",
  staticPage: "staticPage",
  dynamicPage: "dynamicPage"
};
export {
  sitePagesPageType
};
//# sourceMappingURL=types.js.map
